module.exports = __webpack_public_path__ + "static/img/FT.ffb50318.png";